import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTypedDispatch, useTypedSelector } from "App/Store";
import { hideLoader, showLoader } from "redux/action/loaderAction";
import { bracketDetails } from "redux/action/bracketDetailsAction";
import BracketPlayoffDetails from "components/BracketPlayoffDetails";
import ArrowTail from "shared/icons/ArrowTail";
import history from "App/History";
import BracketStandingTable from "components/BracketStanding";
import { TournamentChat } from "components/TournamentChat";
import Tabs from "components/Tabs";
import CommonSchedule from "components/CommonSchedule";
import {  Modal } from "rsuite";
import {
  confirmBracketResult,
  updateBulkSchedule,
  updateResult,
} from "core/services/Bracket";
import { useNotification } from "shared/hooks/useNotification";
import { bracketStandingDetails } from "redux/action/bracketStandingAction";
import BracketDisputeTable from "components/BracketDispute";
import { getBracketDisputeList } from "redux/action/bracketDisputeAction";
import { useQuery } from "shared/hooks/useQuery";
import ResolveDispute from "components/ResolveDispute";
import { DisputedBracket } from "core/models/Bracket";
import { getBracketTeamsDetails } from "redux/action/bracketTeamActionAction";
import ReviewDisputeImage from "components/ReviewDisputeImage";
import { DEFAULT_API_ERROR } from "core/constants/Defaults";
import { Reward } from "core/models/Reward";
import { addVsRewards, getRewards } from "core/services/Groups";
import ViewRewards from "components/ViewRewards";
import PrizeDistribution from "components/PrizeDistribution";
import { playoffVsRoundsList } from "redux/action/playoffVsModeAction";

interface UrlParams {
  playoffId: string;
}

const BLANK_REWARD: Reward = {
  amount: 0,
  id: 0,
  currency: "",
  inGameName: "",
  rewardedBy: 0,
  teamName: "",
  tournamentId: "",
  userId: 0,
  userName: "",
  name: "",
};

export default function BracektPlayoffDetail() {
  const { playoffId } = useParams<UrlParams>();
  const dispatch = useTypedDispatch();
  const [openTournamentChatDrawer, setOpenTournamentChatDrawer] =
    useState(false);
  const [isSchedule, setIsSchedule] = useState(false);
  const [selectedTab, setSelectedTab] = useState("bracket-view");
  const query = useQuery();
  const [playoffOpen, setPlayoffOpen] = useState(false);
  const [selectedSeed, setSelectedSeed] = useState<DisputedBracket>();
  const [selectedImage, setSelectedImage] = useState("");
  const [isImageOpen, setIsImageOpen] = useState(false);
  const [showPrize, setShowPrize] = useState(false);
  const [showReward, setShowReward] = useState(false);
  const [rewards, setRewards] = useState<Reward[]>([]);

  function handleOpenImage(image: string) {
    setSelectedImage(image);
    setIsImageOpen(true);
  }

  function handleCloseImage() {
    setIsImageOpen(false);
    setSelectedImage("");
  }
  const handleDisputeClick = (seed: DisputedBracket) => {
    setSelectedSeed(seed);
    setPlayoffOpen(true);
  };

  useEffect(() => {
    let page = 0;
    if (query.get("page") && !isNaN(Number(query.get("page")))) {
      page = Number(query.get("page"));
    }
    dispatch(getBracketDisputeList(playoffId, { page, size: 8 }));
  }, [dispatch, query, playoffId]);

  function handlePageChange(pageNumber: number) {
    const page = pageNumber - 1;
    dispatch(getBracketDisputeList(playoffId, { page, size: 8 }));
  }

  const {
    brackets,
    tournament,
    isLoading: isBracketsLoading,
  } = useTypedSelector((state) => state.brackets);

    const playoffVsRoundsDetails = useTypedSelector(
    (state) => state.playoffVsRoundsDetails
  );
  const {
    isLoading,
    prizeConfig,
    winnerTeams,
    rewarded,
    tournamentCompleted,
    tournamentDetails,
  } = playoffVsRoundsDetails;

    useEffect(() => {
      dispatch(playoffVsRoundsList({ id: playoffId }));
    }, [dispatch, playoffId]);
  

  const { bracketTeams, isLoading: isTeamsLoading } = useTypedSelector(
    (state) => state.bracketTeams
  );

  const {
    disputedBrackets,
    isLoading: isBracketDisputeLoading,
    count,
    currentPage,
  } = useTypedSelector((state) => state.disputedBracekts);

  const showNotification = useNotification();

  const { standings, isLoading: isStandingLoading } = useTypedSelector(
    (state) => state.standings
  );

  useEffect(() => {
    dispatch(showLoader());
    if (playoffId) {
      dispatch(bracketDetails(playoffId));
    }
    dispatch(hideLoader());
  }, [dispatch, playoffId]);

  useEffect(() => {
    if (selectedSeed) {
      dispatch(getBracketTeamsDetails(selectedSeed.id));
    }
  }, [dispatch, selectedSeed]);

  useEffect(() => {
    dispatch(showLoader());
    if (tournament?.bracketType === "Round Robin") {
      dispatch(bracketStandingDetails(playoffId));
    }
    dispatch(hideLoader());
  }, [dispatch, tournament, playoffId]);

  useEffect(() => {
    if (
      isBracketsLoading ||
      isStandingLoading ||
      isBracketDisputeLoading ||
      isTeamsLoading
    )
      dispatch(showLoader());
    else dispatch(hideLoader());
  }, [
    isBracketsLoading,
    isStandingLoading,
    isBracketDisputeLoading,
    isTeamsLoading,
    dispatch,
  ]);

  const handleClose = () => setPlayoffOpen(false);

  function handleFullScreen() {
    history.push(`/playoff/bracket/details/${tournament?.id}/full-screen`);
  }

  function handleOpenTournamentChatDrawer() {
    setOpenTournamentChatDrawer(true);
  }

  function handleOpenScheduleDrawer() {
    setIsSchedule(true);
  }

  function closeScheduleDrawer() {
    setIsSchedule(false);
  }

  async function onSubmitSchedule(values: any) {
    dispatch(showLoader());

    const schedulePayload = {
      tournamentId: tournament?.id,
      matchesPerDay: values.matchesPerDay,
      startTime: values.startTime,
      matchDuration: values.matchDuration,
      checkInMinutes: values.checkInMinutes,
      gracePeriodMinutes: values.gracePeriodMinutes,
    };

    updateBulkSchedule(schedulePayload).then((res) => {
      if (res.status) {
        showNotification({
          message: "Brackets are Scheduled Successfully",
          title: "Success",
          type: "success",
        });
        closeScheduleDrawer();
      } else {
        showNotification({
          message: "Failed to Update Scheduled",
          title: "Error",
          type: "error",
        });
        closeScheduleDrawer();
      }
      dispatch(hideLoader());
    });
  }

  const TABS = [
    { tabTitle: "View Bracket", key: "bracket-view" },
    ...(tournament?.bracketType === "Round Robin"
      ? [{ tabTitle: "Standing", key: "standing" }]
      : []),
    { tabTitle: "Raised Dispute", key: "dispute" },
  ];

  const processResponse = (res: any, successMsg: string) => {
    if (res.status) {
      showNotification({
        title: "Success",
        message: successMsg,
        type: "success",
      });
      setPlayoffOpen(false);

      dispatch(getBracketDisputeList(playoffId, { currentPage, size: 8 }));
    } else {
      showNotification({
        title: "Error",
        message: res.message || DEFAULT_API_ERROR,
        type: "error",
      });
    }
    dispatch(hideLoader());
  };

  const handleSubmit = (values: any) => {
    if (!selectedSeed) return;

    const payload = {
      id: selectedSeed?.id,
      results: values.results?.map((r: any) => ({
        score: r.score,
        teamId: r.teamId,
      })),
      playerResults: values.playerResults?.map((p: any) => ({
        userId: p.userId,
        stats: p.stats,
      })),
    };
    updateResult(payload).then((res) =>
      processResponse(res, "Result Updated Successfully")
    );
  };

  const handleConfirmResult = () => {
    const payload = {
      bracketId: selectedSeed?.id,
    };
    confirmBracketResult(payload).then((res) =>
      processResponse(res, "Result Confirmed Successfully")
    );
  };

    function handleClosePrize() {
      setShowPrize(false);
    }
  
    function handlePrizeDistributionOpen() {
      setShowPrize(true);
    }
  
    function handlePrizeDistribution(prizeData: any) {
      dispatch(showLoader());
      addVsRewards({ ...prizeData, tournId: playoffId }).then(
        (resp) => {
          if (resp.status && resp.data) {
            dispatch(playoffVsRoundsList({ id: playoffId }));
            showNotification({
              message: "Rewards Added Successfully",
              title: "Success",
              type: "success",
            });
          } else {
            showNotification({
              message: resp.message || DEFAULT_API_ERROR,
              title: "Error",
              type: "error",
            });
          }
          handleClosePrize();
          dispatch(hideLoader());
        }
      );
    }
  
    async function handleViewReward() {
      const rewardRes = await getRewards(playoffId);
      if (rewardRes.status && rewardRes.data) {
        const rewardsData = rewardRes.data.rewards.map((reward) => {
          if (reward.currency === 'XOPOINTS') {
            reward.currency = 'Arena Points'
          } else {
            reward.currency = 'Dirham'
  
          }
          return reward;
        });
      
        setRewards(rewardsData);
        setShowReward(true);
      } else {
        showNotification({
          message: rewardRes.message || DEFAULT_API_ERROR,
          title: "Error",
          type: "error",
        });
      }
    }
  
    function closeViewReward() {
      setTimeout(() => {
        setRewards([]);
      }, 300);
      setShowReward(false);
    }

  return (
    <div className="play-off-detail-page">
      {tournament && brackets && (
        <BracketPlayoffDetails
          tournament={tournament}
          brackets={brackets}
          handleOpenTournamentChatDrawer={handleOpenTournamentChatDrawer}
          handleOpenScheduleDrawer={handleOpenScheduleDrawer}
          handlePrizeDistributionOpen={handlePrizeDistributionOpen}
          handleViewReward={handleViewReward}
          tournamentCompleted={tournamentCompleted}
          rewarded={rewarded}
          prizeConfig={prizeConfig}
        />
      )}

      <div className="tab-section">
        <Tabs
          className="tabs-wrapper"
          tabs={TABS}
          appearance="subtle"
          active={selectedTab}
          onSelect={setSelectedTab}
        />
      </div>

      {selectedTab === "standing" && standings && (
        <BracketStandingTable standings={standings} />
      )}

      {selectedTab === "bracket-view" && (
        <div className="bracket-view-wrapper">
          {tournament && brackets && (
            <div
              className="playoff-fullscreen-wrapper"
              onClick={handleFullScreen}
            >
              <div className="view-screen">View Bracket</div>
              <div className="arrow-wrapper">
                <ArrowTail fontSize="8px" color="#6e6af0" rotate={135} />
              </div>
            </div>
          )}
        </div>
      )}

      {selectedTab === "dispute" && (
        <BracketDisputeTable
          disputes={disputedBrackets}
          count={count}
          currentPage={currentPage}
          onPageChange={handlePageChange}
          handleDisputeClick={handleDisputeClick}
        />
      )}

      {isSchedule && (
        <CommonSchedule
          onClose={closeScheduleDrawer}
          show={isSchedule}
          onSubmit={onSubmitSchedule}
          tournament={tournament}
        />
      )}

      <TournamentChat
        open={openTournamentChatDrawer}
        onClose={() => setOpenTournamentChatDrawer(false)}
        tournament={tournament}
      />

      {bracketTeams && selectedSeed && tournament && (
        <ResolveDispute
          show={playoffOpen}
          onClose={handleClose}
          onSubmit={handleSubmit}
          bracketTeams={bracketTeams}
          seed={selectedSeed}
          tournament={tournament}
          handleOpenImage={handleOpenImage}
          handleConfirmBracketResult={handleConfirmResult}
        />
      )}

      <ReviewDisputeImage
        show={isImageOpen}
        onClose={handleCloseImage}
        imageUrl={selectedImage}
      />


        <Modal onHide={handleClosePrize} show={showPrize} size="md">
          <Modal.Header>
            <Modal.Title>Prize Distribution</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {showPrize && (
              <PrizeDistribution
                onClose={handleClosePrize}
                teams={winnerTeams}
                prizeConfig={prizeConfig}
                onAddRewards={handlePrizeDistribution}
              />
            )}
          </Modal.Body>
        </Modal>
   
        <Modal onHide={closeViewReward} show={showReward} size="lg">
          <Modal.Header>
            <Modal.Title>Rewards</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ViewRewards rewards={rewards} />
          </Modal.Body>
        </Modal>
    </div>
  );
}
